import { LOGOS } from './logos';

// The four geographic market clusters — map geometry + brand directory
// data. All project depth lives in projects.js; directory entries link
// to timeline records via projectId.

export const CLUSTERS = [
  {
    id: 'na',
    code: 'NA—01',
    name: 'North America',
    label: 'NORTH AMERICA',
    countries: ['Canada', 'United States'],
    groupLabels: null,
    labels: {
      world: { lon: -133, lat: 46, anchor: 'middle' },
      americas: { lon: -95, lat: 58, anchor: 'middle' },
    },
    brands: [
      {
        id: 'pantone',
        name: 'Pantone',
        country: 'United States',
        role: 'Creative Director / Producer',
        skills: ['Creative Direction', 'Video Production', 'Creative Production', 'Influencer Campaign Strategy', 'Campaign Development', 'Generative AI Collaboration'],
        logo: LOGOS.pantone,
        projectId: 'pantone',
        group: null,
      },
      {
        id: 'tdbank',
        name: 'TD Bank',
        country: 'Canada',
        role: 'Content Strategist, Events',
        skills: ['Content Strategy', 'Event Content Strategy', 'Event Curation', 'Creative Partnerships', 'Video Content Development', 'Social Media Content', 'Out-of-Home Content Adaptation'],
        logo: LOGOS.tdbank,
        projectId: 'td',
        group: null,
      },
      {
        id: 'canadagoose',
        name: 'Canada Goose',
        country: 'Canada',
        role: 'Content Strategist',
        skills: ['Content Strategy', 'Creative Strategy', 'Sustainability Storytelling', 'Art Direction', 'Campaign Content Development', 'Creative Partnerships'],
        logo: LOGOS.canadagoose,
        projectId: 'goose',
        group: null,
      },
      {
        id: 'valuevillage',
        name: 'Value Village',
        country: 'Canada',
        role: 'Content Strategist, Retail Social Media',
        skills: ['Retail Social Media Strategy', 'UGC Strategy', 'Community-Led Content', 'Influencer Marketing', 'Seasonal Campaigns'],
        logo: LOGOS.valuevillage,
        projectId: 'vv',
        group: null,
      },
    ],
    links: [],
  },
  {
    id: 'uae',
    code: 'UAE—02',
    name: 'United Arab Emirates',
    label: 'UAE',
    countries: ['United Arab Emirates'],
    groupLabels: null,
    labels: {
      world: { lon: 55.5, lat: 15.5, anchor: 'middle' },
      asia: { lon: 55.5, lat: 15.5, anchor: 'middle' },
    },
    brands: [
      {
        id: 'haagendazs',
        name: 'Häagen-Dazs',
        country: 'Dubai, UAE',
        role: 'Creative Producer',
        skills: ['Creative Production', 'Video Production', 'Photography Production', 'Production Team Coordination', 'Brand Film Production', 'Creative Execution'],
        logo: LOGOS.haagendazs,
        projectId: 'haagendazs',
        group: null,
      },
      {
        id: 'careem',
        name: 'Careem',
        country: 'Dubai, UAE',
        role: 'Content Strategist',
        skills: ['Content Strategy', 'Brand Communication', 'Campaign Strategy', 'Market Launch Communication'],
        logo: LOGOS.careem,
        projectId: 'careem',
        group: null,
      },
    ],
    links: [],
  },
  {
    id: 'ind',
    code: 'IND—03',
    name: 'India',
    label: 'INDIA',
    countries: ['India'],
    groupLabels: {
      hul: 'Hindustan Unilever',
      mediacom: 'MediaCom / WPP Media',
      culturemachine: 'Culture Machine',
      independent: 'Independent Creative Consulting',
      freelance: 'Freelance Projects',
    },
    labels: {
      world: { lon: 80.5, lat: 8.5, anchor: 'middle' },
      asia: { lon: 79, lat: 10, anchor: 'middle' },
    },
    brands: [
      { id: 'comfort', name: 'Comfort', country: 'India', group: 'hul', role: 'Social Lead and Content Strategist', skills: ['Social Media Strategy', 'Content Strategy', 'Creative Direction', 'Brand Communication', 'AI-Assisted Creative Workflows', 'Content Production', 'Audience-Focused Storytelling'], logo: LOGOS.comfort, projectId: 'comfort' },
      { id: 'surfexcel', name: 'Surf Excel', country: 'India', group: 'hul', role: 'Social Media Lead', skills: ['Social Media Strategy'], logo: LOGOS.surfexcel, projectId: 'surfexcel' },
      { id: 'hilton-in', name: 'Hilton Hotels', country: 'India', group: 'mediacom', role: 'Content Lead and Creative Supervisor', skills: ['Creative Strategy', 'Content Strategy', 'Creative Supervision', '360-Degree Campaign Development', 'Influencer Marketing', 'Branded Content', 'Media Partnerships'], logo: LOGOS.hilton, projectId: 'hilton-in' },
      { id: 'vivo', name: 'Vivo', country: 'India', group: 'mediacom', role: 'Content Lead', skills: ['Content Strategy', 'Content Leadership', 'Branded Content', 'Photography Campaign Development', 'Product Storytelling', 'Creative Direction'], logo: LOGOS.vivo, projectId: 'vivo' },
      { id: 'subway', name: 'Subway', country: 'India', group: 'mediacom', role: 'Content Lead and Brand Liaison', skills: ['Creative Strategy', 'Content Strategy', 'Music-Led Campaign Development', 'Brand Partnerships', 'Branded Entertainment', 'Video Production'], logo: LOGOS.subway, projectId: 'subway' },
      { id: 'bosch', name: 'Bosch', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist, MediaCom', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.bosch, projectId: 'bosch' },
      { id: 'shell', name: 'Shell', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist — content strategy and campaign development', skills: ['Branded Content Strategy', 'Automotive Content', 'Editorial Partnerships', 'Content Integration', 'Video Content Development'], logo: LOGOS.shell, projectId: 'shell' },
      { id: 'porsche', name: 'Porsche India', country: 'India', group: 'mediacom', role: 'Production Supervisor and Content Direction', skills: ['Production Supervision', 'Creative Direction', 'Event Content', 'Video Production', 'Automotive Storytelling'], logo: LOGOS.porsche, projectId: 'porsche' },
      { id: 'bajajfinserv', name: 'Bajaj Finserv', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.bajajfinserv, projectId: null },
      { id: 'parle', name: 'Parle', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.parle, projectId: null },
      { id: 'gillette', name: 'Gillette', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.gillette, projectId: null },
      { id: 'vicks', name: 'Vicks', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.vicks, projectId: null },
      { id: 'dabur', name: 'Dabur', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.dabur, projectId: null },
      { id: 'cocacola', name: 'Coca-Cola', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.cocacola, projectId: null },
      { id: 'adidas', name: 'Adidas', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.adidas, projectId: null },
      { id: 'citroen', name: 'Citroën', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.citroen, projectId: null },
      { id: 'lionsgateplay', name: 'Lionsgate Play', country: 'India', group: 'mediacom', role: 'Creative and Content Strategist', skills: ['Creative Strategy', 'Content Strategy'], logo: LOGOS.lionsgateplay, projectId: null },
      { id: 'epified', name: 'Epified', country: 'India', group: 'culturemachine', role: 'Video Producer', skills: ['Video Production', 'Scriptwriting', 'Creative Writing', 'Art Direction', 'Mythology Research', 'Storytelling'], logo: LOGOS.epified, projectId: 'epified' },
      { id: 'beingindian', name: 'Being Indian', country: 'India', group: 'culturemachine', role: 'Video Producer', skills: [], logo: LOGOS.beingindian, projectId: 'beingindian' },
      { id: 'dronestark', name: 'Dronestark', country: 'India', group: 'independent', role: 'Independent Creative Consultant', skills: ['Brand Strategy', 'Visual Identity', 'Logo and Brand Guidelines', 'Content Strategy', 'Social Media Strategy', 'Company Profile and Sales Communication'], logo: LOGOS.dronestark, projectId: 'dronestark' },
      { id: 'mimamsa', name: 'Mimamsa', country: 'India', group: 'independent', role: 'Independent Creative Consultant', skills: ['Personal Branding', 'Integrated Marketing Strategy', 'Website Strategy', 'Social Media Strategy', 'LinkedIn Outreach', 'Performance Marketing'], logo: LOGOS.mimamsa, projectId: 'mimamsa' },
      { id: 'govdco', name: 'Government of India', country: 'India', group: 'freelance', role: 'Producer and Post-Production Lead', skills: ['Documentary Production', 'Field Production', 'Production Coordination', 'Post-Production Management', 'Video Editing'], logo: LOGOS.govdco, projectId: 'govdoc' },
      { id: 'della', name: 'Della Adventures and Resorts', country: 'India', group: 'freelance', role: 'Content Lead', skills: ['Content Leadership', 'Team Management', 'Video Production', 'Travel Content', 'Experiential Storytelling'], logo: LOGOS.della, projectId: 'della' },
    ],
    links: [],
  },
  {
    id: 'sea',
    code: 'SEA—04',
    name: 'Southeast Asia',
    label: 'SOUTHEAST ASIA',
    countries: ['Singapore', 'Indonesia'],
    groupLabels: null,
    labels: {
      world: { lon: 121, lat: -14.5, anchor: 'middle' },
      asia: { lon: 130, lat: -7.5, anchor: 'end' },
    },
    brands: [
      {
        id: 'hilton-sea',
        name: 'Hilton Hotels',
        country: 'Singapore & Indonesia',
        role: 'Creative Lead',
        skills: ['Creative Strategy', 'Content Adaptation', 'Campaign Supervision', 'Regional Campaign Execution', 'Multi-Market Content Strategy'],
        logo: LOGOS.hilton,
        projectId: 'hilton-sea',
        group: null,
        note: 'Regional adaptation of the original India campaign, Goa Beyond the Beaches.',
      },
    ],
    links: [],
  },
];

// Mobile map panes — deliberately focused compositions. Desktop keeps
// the full-world framing.
export const PANES = [
  {
    id: 'americas',
    caption: 'The Americas',
    W: 400,
    H: 430,
    bbox: { lonMin: -142, lonMax: -52, latMin: -8, latMax: 72 },
    clusterIds: ['na'],
  },
  {
    id: 'asia',
    caption: 'Asia & The Gulf',
    W: 400,
    H: 400,
    bbox: { lonMin: 40, lonMax: 132, latMin: -10, latMax: 63 },
    clusterIds: ['uae', 'ind', 'sea'],
  },
];

export const VIEWS = {
  world: { W: 1000, H: 620, bbox: null },
  americas: { W: 400, H: 430, bbox: { lonMin: -142, lonMax: -52, latMin: -8, latMax: 72 } },
  asia: { W: 400, H: 400, bbox: { lonMin: 40, lonMax: 132, latMin: -10, latMax: 63 } },
};
